import turfIntersect from "@turf/intersect";

export default function intersect(feature1, feature2) {
    return turfIntersect(feature1, feature2);
};
